import React from 'react';
import Button from '@fff-web/fff-ui-shared/Button';
import styles from './HeroBanner.module.scss';

type HeroBannerProps = {
  headline: string;
  disclaimer: string;
  caption: string;
  mainCTA: string;
  ctaOnClick?: () => void;
};

const HeroBanner: React.FC<HeroBannerProps> = ({
  headline,
  caption,
  mainCTA,
  disclaimer,
  ctaOnClick,
}) => (
  <section className={styles.wrapperHero}>
    <h1 className={styles.headline}>{headline}</h1>
    <h2 className={styles.caption}>{caption}</h2>
    <p className={styles.disclaimer}>{disclaimer}</p>
    <div className={styles.buttonWrapper}>
      <Button onClick={ctaOnClick}>{mainCTA}</Button>
    </div>
  </section>
);

export default HeroBanner;
